module.exports = __webpack_public_path__ + "img/attendance-banner.674ce30.png";